import React, { FC, useCallback } from "react";
import { RaisedButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { useImportDialog } from "../../../../hooks/useDialogs";
import { NoResource } from "./NoResource";

interface NoTablesProps {
  headerText: string;
}

export const NoTables: FC<NoTablesProps> = ({ headerText }) => {
  const { t } = useTranslation("catalog");
  const openImportDialog = useImportDialog();
  const handleImport = useCallback(() => openImportDialog(), [openImportDialog]);

  return (
    <NoResource headerText={headerText}>
      <RaisedButton primary onClick={handleImport}>
        {t("uploadData")}
      </RaisedButton>
    </NoResource>
  );
};
